import {
    EMPLOYEE_LOADING,
    EMPLOYEE_ERRORS,
    FETCH_ADMINISTRATORS_SUCCESS,
    FETCH_HR_SUCCESS,
    FETCH_SUPERVISORS,
    FETCH_SUPERVISORS_SUCCESS,
    FETCH_ACCOUNT_MANAGERS_SUCCESS,
    FETCH_HELPERS_SUCCESS,
    FETCH_EMPLOYEES,
    FETCH_EMPLOYEES_SUCCESS,
    FETCH_MERCHANDISERS,
    FETCH_MERCHANDISERS_SUCCESS,
    FETCH_EMPLOYEE_SUCCESS,
    FETCH_EMPLOYEE_AVAILABILITY,
    FETCH_EMPLOYEE_AVAILABILITY_SUCCESS,
    FETCH_EMPLOYEE_SCHEDULED_WORK,
    FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS,
    REMOVE_SINGLE_EMPLOYEE,
    INVOICE_REQUEST_LOADING,
} from "actions/types";

import {
    getAdministrators,
    getHR,
    getAccountManagers,
    getHelpers,
    getSupervisors,
    getMerchandisers,
    getEmployees,
    getEmployeeAvailability,
    getEmployeeScheduledWork
} from "api/employeeApi";

export const setLoading = () => ({
    type: INVOICE_REQUEST_LOADING
});
export const setEmployeeLoading = () => ({
  type: EMPLOYEE_LOADING
});

export const setEmployeeError = (payload) => ({
  type: EMPLOYEE_ERRORS,
  payload,
});

export const setEmployees = payload => ({
  type: FETCH_EMPLOYEES_SUCCESS,
  payload
});

export const setEmployee = payload => ({
  type: FETCH_EMPLOYEE_SUCCESS,
  payload
});

export const setEmployeeAvailability = payload => ({
  type: FETCH_EMPLOYEE_AVAILABILITY_SUCCESS,
  payload
});

export const removeSingleEmployee = () => ({
  type: REMOVE_SINGLE_EMPLOYEE,
});

export const fetchAdministrators = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_ADMINISTRATORS_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setEmployeeLoading());
    getAdministrators()
        .then(response => {
            dispatch({
                type: FETCH_ADMINISTRATORS_SUCCESS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setEmployeeError({ type: FETCH_SUPERVISORS, message: "Could not fetch Administrators." }));
        });
};

export const fetchHR = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_HR_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setEmployeeLoading());
    getHR()
        .then(response => {
            dispatch({
                type: FETCH_HR_SUCCESS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setEmployeeError({ type: FETCH_SUPERVISORS, message: "Could not fetch HR." }));
        });
};

export const fetchSupervisors = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_SUPERVISORS_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setEmployeeLoading());
    getSupervisors()
        .then(response => {
            dispatch({
                type: FETCH_SUPERVISORS_SUCCESS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setEmployeeError({ type: FETCH_SUPERVISORS, message: "Could not fetch Supervisors." }));
        });
};

export const fetchMerchandisers = (reset) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_MERCHANDISERS_SUCCESS,
            payload: []
        });
        return true;
    }
    dispatch(setEmployeeLoading());
        getMerchandisers()
            .then(response => {
                dispatch({
                    type: FETCH_MERCHANDISERS_SUCCESS,
                    payload: response.data
                });
            })
            .catch(() => {
                dispatch(setEmployeeError({
                    type: FETCH_MERCHANDISERS,
                    message: "Could not fetch Merchandisers."
                }));
            });
};

export const emptyMerchandiser = () => ({
    type: FETCH_MERCHANDISERS_SUCCESS,
    payload: []
});

export const fetchAccountManagers = () => dispatch => {
    dispatch(setLoading(true));
    getAccountManagers()
        .then(response => {
            dispatch({
                type: FETCH_ACCOUNT_MANAGERS_SUCCESS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setEmployeeError({ type: FETCH_SUPERVISORS, message: "Could not fetch Account Managers." }));
        });
};

export const clearAccountManagers = () => dispatch => {
   dispatch({
        type: FETCH_ACCOUNT_MANAGERS_SUCCESS,
        payload: []
    });
};

export const fetchHelpers = () => dispatch => {
    dispatch(setEmployeeLoading());
    getHelpers()
        .then(response => {
            dispatch({
                type: FETCH_HELPERS_SUCCESS,
                payload: response.data
            });
        })
        .catch(() => {
            dispatch(setEmployeeError({ type: FETCH_SUPERVISORS, message: "Could not fetch Helpers." }));
        });
};

export const clearHelpers = () => dispatch => {
    dispatch({
        type: FETCH_HELPERS_SUCCESS,
        payload: []
    });
};


export const fetchEmployees = (
  storeId,
  distance,
  provinceId,
  cityIds,
  isReside,
  isTravel,
  commodityIds,
  retailerIds,
  minimumAvailability,
  startDate,
  endDate,
  supervisorIds,
  name
) => dispatch => {
  dispatch(setEmployeeLoading());
  getEmployees(
    storeId,
    distance,
    provinceId,
    cityIds,
    isReside,
    isTravel,
    commodityIds,
    retailerIds,
    minimumAvailability,
    startDate,
    endDate,
    supervisorIds,
    name
  )
    .then(response => {
      dispatch(setEmployees(response.data));
    })
    .catch(() => {
      dispatch(setEmployeeError({ type: FETCH_EMPLOYEES, message: "Could not fetch employees." }));
    });
};

export const clearEmployees = () => dispatch => {
    dispatch({
        type: FETCH_EMPLOYEES_SUCCESS,
        payload: []
    });
};

export const fetchEmployeeAvailability = (workerId) => dispatch => {
  // dispatch(setEmployeeLoading());
  getEmployeeAvailability(workerId)
    .then(response => {
      // console.warn("getEmployeeAvailability", response.data);
      dispatch(setEmployeeAvailability(response.data));
    })
    .catch(() => {
      dispatch(setEmployeeError({ type: FETCH_EMPLOYEE_AVAILABILITY, message: "Could not fetch employee." }));
    });
};

/* ScheduledWork */
export const setEmployeeScheduledWork = payload => ({
  type: FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS,
  payload
});

export const fetchEmployeeScheduledWork = (workerId) => dispatch => {
  getEmployeeScheduledWork(workerId)
    .then(response => {
      dispatch(setEmployeeScheduledWork(response.data));
    })
    .catch(() => {
      dispatch(setEmployeeError({
          type: FETCH_EMPLOYEE_SCHEDULED_WORK,
          message: "Could not fetch employee scheduled works."
      }));
    });
};
